import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as logger from "../../../logger";
import { deleteVendorPayment } from '../../../store/actions/tripActionCreator';
import { deletePartyPayment } from '../../../store/actions/partiesActionCreator';
import { connect } from "react-redux";
import { sendSucces } from '../../../utils/utils';

const useStyles = makeStyles((theme) => ({
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    divV1: {
        fontWeight: 300, fontSize: 16
    }
}));

const DeleteSupplierPaymentDialog = ({ open, paymentId, onConfirm, onClose, dispatchDeleteVendorPayment, calledFrom, dispatchDeletePartyPayment }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onDelete = () => {
        if (calledFrom == "passBookTabSupplier") {
            dispatchDeleteVendorPayment(paymentId,
                null,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Delete Supplier Payment Dialog Dweb", "Delete Payment Successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Delete Supplier Payment Dialog Dweb", "Delete Payment Failed");
                }
            )
        } else if (calledFrom == "passBookTabParty") {
            dispatchDeletePartyPayment(paymentId,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Delete Supplier Payment Dialog Dweb", "Delete Payment Successfull");
                        sendSucces("Payment deleted successfully");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Delete Supplier Payment Dialog Dweb", "Delete Payment Failed");
                }
            )
        }
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV1}>Are you sure you want to delete the Payment?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDelete}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    dispatchDeleteVendorPayment: (paymentId, data, onSuccess, onError) => {
        dispatch(deleteVendorPayment(paymentId, data, onSuccess, onError))
    },
    dispatchDeletePartyPayment: (paymentId, onSuccess, onError) => {
        dispatch(deletePartyPayment(paymentId, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSupplierPaymentDialog);